export const VITE_API_V1_URL = `${import.meta.env.VITE_BASE_URL}/api/v1`;
export const VITE_API_V2_URL = `${import.meta.env.VITE_BASE_URL}/api/v2`;
export const VITE_INVOICE_FINANCE_URL = `${import.meta.env.VITE_INVOICE_FINANCE_URL}`;
export const DEFAULT_LANGUAGE = "en";
export const API_REQUEST_TIMEOUT_MS = 30_000;

const isMainEnv = import.meta.env.VITE_ENV === "main";
const currentOrigin =
  typeof window !== "undefined" ? window.location.origin : "https://app.incomlend.com";

export const HOME = isMainEnv ? "https://incomlend.com/" : `${currentOrigin}/`;
export const URL = isMainEnv ? "https://app.incomlend.com" : currentOrigin;
export const SUPPORT_EMAIL = "support@incomlend.com";
export const TNC_URL = `${
  import.meta.env.VITE_BASE_URL
}/static/public/terms_and_conditions.pdf`;
// export const TNC_URL = `https://dev.backend.incomlend.com/static/public/terms_and_conditions.pdf`;
export const ONBOARDING = "ONBOARDING";
export const ONBOARDED = "ONBOARDED";
export const PRESALES = "PRESALES";
//App States
export const NEW_USER = "NEW_USER";
//Investor
export const INVESTOR_USER = "INVESTOR_USER";

export const INCOMLEND_INTERNAL = "Incomlend";
export const INCOMLEND_INTERNAL_NAME = "Incomlend Pte Ltd";
export const SELECT_ACCOUNT = "SELECT_ACCOUNT";

//--client--
export const SUPPLIER = "Supplier";
export const SELLER = "seller";
export const BUYER = "Buyer";
export const INVESTOR = "Investor";

export const ROLE_ADMIN = "ADMIN";
export const ROLE_MEMBER = "MEMBER";
//API Response states
export const VERIFY_USER = "VERIFY_USER";
export const SUCCESS = "SUCCESS";
//Company States
export const REGISTERED = "REGISTERED";
export const DOCS_UPLOADED = "DOCS_UPLOADED";
export const ADD_PARTNER = "ADD_PARTNER";
export const TP_ADDED = "TP_ADDED";
export const ATRADIUS_PENDING = "ATRADIUS_PENDING";
export const ATRADIUS_REJECTED = "ATRADIUS_REJECTED";
export const CL_APPROVED = "CL_APPROVED";
export const CL_REQUESTED = "CL_REQUESTED";
export const PENDING_RISK = "PENDING_RISK";
export const PENDING_INSURER = "PENDING_INSURER";
export const CL_REJECTED = "CL_REJECTED";
export const REJECTED_BY_RISK = "REJECTED_BY_RISK";
export const REJECTED_BY_COUNTRY_MATRIX = "REJECTED_BY_COUNTRY_MATRIX";
export const REJECTED_BY_INSURER = "REJECTED_BY_INSURER";
export const ICL_APPROVAL = "ICL_APPROVAL";
export const ICL_REJECTED = "ICL_REJECTED";
export const MANUAL = "manual";
export const CHANGES_REQUESTED = "CHANGES_REQUESTED";

//TERMSHEET_STATUSES
export const IN_PROGRESS = "IN_PROGRESS";
export const PENDING_APPROVAL_HOS = "PENDING_APPROVAL_HOS"; //PENDING_INTERNAL
export const REJECTED_BY_HOS = "REJECTED_BY_HOS"; //REJECTED_INTERNAL
export const CUSTOMER_REJECTED = "CUSTOMER_REJECTED"; //REJECTED
export const PENDING_CUSTOMER_APPROVAL = "PENDING_CUSTOMER_APPROVAL"; //PENDING_EXTERNAL
export const CUSTOMER_APPROVED = "CUSTOMER_APPROVED"; //APPROVED
export const INVOICE_CANCELLED = "INVOICE_CANCELLED"; //INVOICE_CANCELLED
export const TERMSHEET_CANCELLED = "TERMSHEET_CANCELLED"; //TERMSHEET_CANCELLED

//BILLING_STATUSES
export const BILLING_STATUSES = {
  PAYMENT_PENDING: "PAYMENT_PENDING",
  PAID: "PAID",
  EXPIRED: "EXPIRED",
};

//ROUTES
export const INCOMLEND_INTERNAL_LINK = "/incomlend";
export const CONFIRM_OTP = "/confirm-otp";
export const RISK_LINK = "/cl-requests";
export const MAPS = "/maps";
/** Entity ID for Maps list page comments (notifications API). Same pattern as Lead comments. */
export const MAPS_COMMENTS_ENTITY_ID = "maps";
export const LEGAL_LINK = "/countries";
export const FUNDER_LINK = "/invoice-statuses";
export const FUNDER_MANAGEMENT_LINK = "/funder-management";
export const COMPLIANCE_LINK = "/compliance-dashboard";
export const CREDIT_LIMITS_LINK = "/credit-limits";
export const IT_LINK = "/tech";
export const DASHBOARD = "/dashboard";
export const LOGIN = "/login";
export const COMPANIES = "/companies";
export const LEADS_TABLE = "/leads-table";
export const LEADS = "/leads";
export const ACCOUNTS = "/accounts";
export const CAMPAIGN_TESTING = "/test-campaign";
export const REGISTRATION_FORM_PATH = "/registration-form";
export const TR_LINK = "/trading-relationships";
export const USERS_LINK = "/users";
export const BALANCES_LINK = "/balances";
export const SOFR_LINK = "/sofr-rates";
export const HEALTH_CHECK_LINK = "/health-check";
export const TAX_INVOICES_LINK = "/tax-invoices";
export const TERMSHEETS_LINK = "/termsheets";
export const BILLINGS_LINK = "/billings";
export const WITHDRAWL_DEPOSIT_LINK = "/withdrawl-deposits";
export const SUPPORT = "/support";
export const ORG_CHART_LINK = "/org-chart";
export const EMAILS_LINK = "/emails";
export const BOOK_MEETING = "/book-meeting";
export const INVOICE_FINANCING_LINK = "/invoice-financing";
// ----PRESALES
export const ADD_COMPANY = "/companies/add";
export const SELECT_COMPANY = "/companies/add/select-company";
export const REGISTER_FOR_FINANCING = "/register-for-financing";
export const REGISTER_COMPANY = "/register-for-financing/add/register";
export const UPLOAD_DOCUMENTS = "/companies/add/upload-documents";
export const ADD_PARTNERS = "/register-for-financing/add/partners";
export const ADD_CREDIT_LIMITS = "/register-for-financing/add/credit-limit";
export const ADD_CREDIT_LIMIT_ALLOCATION =
  "/register-for-financing/add/credit-limit-allocation";

// --- INVESTOR DASHBOARD
export const INVESTOR_DASHBOARD = "/investor/dashboard";
export const INVESTOR_MASTER_DASHBOARD = "/investor/master-dashboard";
export const INVESTOR_ALLOCATIONS = "/investor/allocations";
export const INVESTOR_FACTSHEET = "/investor/factsheet";
export const INVESTOR_TRANSACTIONS = "/investor/transactions";
export const INVESTOR_MONTHLY_AUM = "/investor/monthly-aum";
export const INVESTOR_GUIDES = "/investor/guides";
export const INVESTOR_IMPORTER_REPAYMENT = "/investor/importerrepayment";
export const INVESTOR_INVOICE_DETAILS = "/investor/invoice-details";
export const INVESTOR_ACTIVE_INVOICES_VISUALIZATION =
  "/investor/active-invoices-visualization";

//AGENT DASHBOARD
export const AGENT_DASHBOARD = "/agent/dashboard";
export const AGENT_CREDIT_LIMITS_LINK = "/agent/credit-limits";
export const AGENT_TERMSHEETS = "/agent/tremsheets";
export const AGENT_LEADS = "/agent/leads";
export const AGENT_EWALLET = "/agent/ewallet";

//LOGIN STATES
export const INITIALIZING = "INITIALIZING";
export const IS_VERIFYING_OTP = "IS_VERIFYING_OTP";
export const IS_VERIFYING_TOTP = "IS_VERIFYING_TOTP";
export const IS_REQUESTING_NEW_PASS = "IS_REQUESTING_NEW_PASS";
export const IS_LOGIN = "IS_LOGIN";
export const IS_VERIFYING_NEW_PASS = "IS_VERIFYING_NEW_PASS";
export const IS_LOGIN_ONBOARDED = "IS_LOGIN_ONBOARDED";
export const ELIGIBILITY_LINK = "eligibility.incomlend.com";

//PRODUCTS
export const PRODUCTS = {
  factoring: "factoring",
  reverse_factoring: "reverse_factoring",
  inventory_financing: "inventory_financing",
};

export const TURNOVER_TYPE = {
  selective: "selective",
  full: "full",
} as const;

//PRODUCTS
export const ROLE = {
  inrernal: "inrernal",
  external: "external",
};

export const FINANCE_TYPE = {
  receivable_financing: "Receivable Financing",
  payable_financing: "Payable Financing",
};
export const PRODUCTS_TITEL = {
  factoring: "Export",
  reverse_factoring: "Import",
};

//INVOICE: PHASE STATUS ENUM
export const PHASE_STATUS = {
  PRE_LISTING: 0,
  ON_MARKETPLACE: 1,
  IN_PROGRESS: 2,
  OVERDUE: 3,
  PAID: 4,
  PASSTHROUGH_INVOICES: 5,
};

export const TERMSHEET_STATUS = {
  IN_PROGRESS: "IN_PROGRESS",
  PENDING_APPROVAL_HOS: "PENDING_APPROVAL_HOS", //PENDING_INTERNAL
  REJECTED_BY_HOS: "REJECTED_BY_HOS", //REJECTED_INTERNAL
  PENDING_CUSTOMER_APPROVAL: "PENDING_CUSTOMER_APPROVAL", //PENDING_EXTERNAL
  CUSTOMER_APPROVED: "CUSTOMER_APPROVED", //APPROVED
  CUSTOMER_REJECTED: "CUSTOMER_REJECTED", //REJECTED
  CANCELLED: "CANCELLED",
};

export const ANNUAL_INVOICE_VOLUME = "annual_invoice_volume";
export const INVOICE_FACE_VALUE = "invoice_face_value";
export const FACILITY_FEE_TYPES = [
  { name: "Per installment", value: ANNUAL_INVOICE_VOLUME },
  { name: "Per invoice", value: INVOICE_FACE_VALUE },
];

export const DEFAULT_FACILITY_FEE_TYPE = ANNUAL_INVOICE_VOLUME;

//CURRENCIES
export const CURRENCIES: Record<string, any> = {
  USD: { name: "USD", abb: "US$", flag: "🇺🇸" },
  SGD: { name: "SGD", abb: "S$", flag: "🇸🇬" },
  HKD: { name: "HKD", abb: "HK$", flag: "🇭🇰" },
  GBP: { name: "GBP", abb: "£", flag: "🇬🇧", disabled: true },
  EUR: { name: "EUR", abb: "€", flag: "🇪🇺" },
  AUD: { name: "AUD", abb: "A$", flag: "🇦🇺", disabled: true },
  INR: { name: "INR", abb: "₹", flag: "🇮🇳", disabled: true },
};

export const DEFAULT_HIDEABLES = [
  "supplierRegNo",
  "supplierCountry",
  "buyerRegNo",
  "buyerCountry",
];
//CL Slider indications
export const MIN_CL = 50000; //updated on 21/2/24, src: slack
export const MAX_CL = 5000000; //updated on 21/2/24, src: slack
export const CL_STEP = 250000;
export const CL_DEFAULT = 250000;
export const DEFAULT_ROWS = 10;

export const SHIPMENT_STATUSES: Record<number, string> = {
  0: "Booked",
  1: "Collected from Shipper",
  2: "Not arrived at Port of Load",
  3: "Waiting at Port of Load",
  4: "Shipped on board",
  5: "Underway",
  6: "Underway to a Transhipment Port (to be added soon)",
  7: "Arrival at Transhipment Port (to be added soon)",
  8: "Waiting at Transhipment Port",
  9: "Shipped on board at Transhipment Port",
  10: "Arrived at Port or Discharge",
  11: "Waiting at Destination Port",
  12: "Left the Destination Port",
  13: "Shipment Completed",
};

// Groups and Grouplist
export const ORIGINATION_ADMIN = "ORIGINATION_ADMIN";
export const ORIGINATION_MEMBER = "ORIGINATION_MEMBER";
export const MARKETING_ADMIN = "MARKETING_ADMIN";
export const MARKETING_MEMBER = "MARKETING_MEMBER";
export const IT_ADMIN = "IT_ADMIN";
export const IT_MEMBER = "IT_MEMBER";
export const RISK_ADMIN = "RISK_ADMIN";
export const RISK_MEMBER = "RISK_MEMBER";
export const COMPLIANCE_ADMIN = "COMPLIANCE_ADMIN";
export const COMPLIANCE_MEMBER = "COMPLIANCE_MEMBER";
export const LEGAL_ADMIN = "LEGAL_ADMIN";
export const LEGAL_MEMBER = "LEGAL_MEMBER";
export const FUNDING_ADMIN = "FUNDING_ADMIN";
export const FUNDING_MEMBER = "FUNDING_MEMBER";
export const FINANCE_ADMIN = "FINANCE_ADMIN";
export const FINANCE_MEMBER = "FINANCE_MEMBER";
export const OPERATION_ADMIN = "OPERATION_ADMIN";
export const OPERATION_MEMBER = "OPERATION_MEMBER";
export const ACCOUNT_MEMBER = "ACCOUNT_MEMBER";
export const ACCOUNT_ADMIN = "ACCOUNT_ADMIN";
//--Includes Incomlend Internal--
export const GROUP_LIST = [
  ORIGINATION_ADMIN,
  ORIGINATION_MEMBER,
  MARKETING_ADMIN,
  MARKETING_MEMBER,
  IT_ADMIN,
  IT_MEMBER,
  RISK_ADMIN,
  RISK_MEMBER,
  COMPLIANCE_ADMIN,
  COMPLIANCE_MEMBER,
  LEGAL_ADMIN,
  LEGAL_MEMBER,
  FUNDING_ADMIN,
  FUNDING_MEMBER,
  FINANCE_ADMIN,
  FINANCE_MEMBER,
  OPERATION_ADMIN,
  OPERATION_MEMBER,
  ACCOUNT_MEMBER,
  ACCOUNT_ADMIN,
  INCOMLEND_INTERNAL, // To detect whether its an internal user
];

//Platform Usage

export const PLATFORM_USAGE_CATEGORIES = [
  "Signups",
  "Submitted Companies",
  "Tracked Shipments",
  "Submitted Credit Limits",
  "Approved Credit Limits",
  "Rejected Credit Limits",
  "Started Onboardings",
  "Submitted Onboardings",
];

//Company address
export const COMPANY_ADDRESS = {
  name: "Incomlend Pte Ltd",
  addressLine1: "112 Robinson Road, #12-03A",
  addressLine2: "Singapore 068902",
  phone: "+65 3158 2540",
  registrationNumber: "201600941W",
};

export const INCOMLEND_PRODUCTS = {
  standard_factoring: "standard_factoring",
  standard_reverse_factoring: "standard_reverse_factoring",
  enhanced_factoring: "enhanced_factoring",
  big_buyer: "big_buyer",
};

export const PRODUCT_CATEGORY_VALUES = {
  factoring: "factoring",
  reverse_factoring: "reverse_factoring",
  enhanced_factoring: INCOMLEND_PRODUCTS.enhanced_factoring,
  standard_factoring: INCOMLEND_PRODUCTS.standard_factoring,
  regular_factoring: "regular_factoring",
} as const;

export const PRODUCT_CATEGORY_LABELS = {
  factoring: "Factoring",
  reverse_factoring: "Reverse Factoring",
  enhanced_factoring: "Enhanced Factoring",
  standard_factoring: "Standard Factoring",
  regular_factoring: "Regular Factoring",
} as const;

export const INVOICE_STATUSES = {
  expected: "Expected",
  loaded: "Loaded",
  pending_incomlend_review: "Pending Incomlend Review",
  pending_buyer_request_approval_resubmission:
    "Pending Buyer Request Approval Resubmission",
  cancelled_by_incomlend: "Cancelled by Incomlend",
  pending_for_cma_approval: "Pending for CMA Approval",
  pending_buyer_and_forwarder_confirmation:
    "Pending Buyer and Forwarder Confirmation",
  pending_buyer_confirmation: "Pending Buyer Confirmation",
  pending_freight_forwarders_confirmation:
    "Pending Freight Forwarders Confirmation",
  pending_supplier_review: "Pending Supplier Review",
  pending_incomlend_final_review: "Pending Incomlend Final Review",
  approved_for_listing: "Approved for Listing",
  cancelled_by_supplier_before_listing: "Cancelled by Supplier before Listing",
  on_marketplace_waiting_for_auction_to_start:
    "On Marketplace - Waiting for Auction to Start",
  on_marketplace: "On Marketplace",
  funded_waiting_for_auction_finish: "Funded - Waiting for Auction Finish",
  cancelled_did_not_achieve_minimum_funding_amount:
    "Cancelled - Did not achieve minimum funding amount",
  funded_waiting_for_fund_distribution_to_supplier:
    "Funded - Waiting for Fund Distribution to Supplier",
  in_progress: "In Progress",
  repayment_received_waiting_for_funds_distribution:
    "Repayment Received - Waiting for Funds Distribution",
  paid: "Paid",
  collections: "Collections",
  delayed: "Delayed",
  awaiting_due_date: "Awaiting Due Date",
};
